export default __webpack_public_path__ + "static/media/logo02.9b06f0f1.svg";